import { BroadcastStatus } from '../../../../../types';

export interface BroadcastCreationEntitlement {
    broadcastAllowed?: boolean;
    broadcastFeatureEnabled?: boolean;
}

export const canCreateBroadcast = (user?: BroadcastCreationEntitlement | null) =>
    Boolean(user?.broadcastAllowed) && Boolean(user?.broadcastFeatureEnabled);

interface ExistingBroadcastControlParams {
    hasUser: boolean;
    isModerator: boolean;
    broadcastStatus: BroadcastStatus;
}

export const canControlExistingBroadcast = ({
    hasUser,
    isModerator,
    broadcastStatus,
}: ExistingBroadcastControlParams) => hasUser && isModerator && broadcastStatus !== BroadcastStatus.NONE;
